import React from "react";
import { Box } from "@mui/material";
import { StatusBackgroundMap } from "../../Dashboard/FlowItem";
import { BookingStatus } from "../../Bookings/ManageBooking";

const StatusIndicator = ({ status }: { status: string }): React.ReactElement => {
  const isReservedStatus = status === BookingStatus.reserved;

  return (
    <Box
      sx={{
        background: StatusBackgroundMap[status],
        borderRadius: "50%",
        width: "8px",
        height: "8px",
        marginRight: "4px",
        display: "inline-block",
        ...(isReservedStatus && { border: "1px solid black" })
      }}
    />
  );
};

export default StatusIndicator;
